import React from "react";
import { Button, HStack, Spacer, Text, VStack } from "@chakra-ui/react";
import { ImageType, useDrawing, useField } from "duck";
import styles from "./DigitalSignature.module.css";

interface DigitalSignatureProps {
  label?: React.ReactNode;
  name: string;
  onChange?(file: null | ImageType): void;
  value?: number | ImageType | null;
}

const DigitalSignature: React.FC<DigitalSignatureProps> = ({
  label,
  name,
  onChange: customOnChange,
  value: customValue
}) => {
  const formProps = useField(name);

  const onChange =
    formProps.onChange === undefined
      ? customOnChange || (() => {})
      : formProps.onChange;
  const value = formProps.value ?? customValue;

  const onStopDrawing = (base64: string) => {
    onChange({ base64Format: base64, name: "signature" });
  };

  const {
    canvasRef,
    draw,
    stopDrawing,
    startDrawing,
    toolsConfig
  } = useDrawing("100%", "250px", value, onStopDrawing);

  const clearSignature = () => {
    toolsConfig.clear();
    onChange(null);
  };

  return (
    <VStack alignItems="right" spacing={7}>
      <VStack position="relative">
        <canvas
          className={styles.canvasWrapper}
          ref={canvasRef}
          onMouseDown={startDrawing}
          onTouchStart={startDrawing}
          onMouseMove={draw}
          onTouchMoveCapture={draw}
          onMouseUp={stopDrawing}
          onTouchEnd={stopDrawing}
          onMouseLeave={stopDrawing}
        />
        <Text fontWeight={600} position="absolute" top="210px">
          {label}
        </Text>
      </VStack>
      <HStack alignItems="right">
        <Spacer />
        <Button onClick={clearSignature} variant="outline" colorScheme="gray">
          Clear Signature
        </Button>
      </HStack>
    </VStack>
  );
};

export default DigitalSignature;
